import styled from '@emotion/styled'
import { colors } from '@resiliatech/birdsong'
import { Popover as MuiPopover } from '@material-ui/core'

// Main container for the component
export const Container = styled.div`
  width: 100%;
`

// Button container for the upload button
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;

  .birdsong-button {
    border-radius: 20px;
    padding: 6px 16px;
  }
`

// Popover styles
export const Popover = styled(MuiPopover)`
  .MuiPopover-paper {
    width: 580px;
    height: 480px;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    position: fixed;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    max-height: 90vh;
  }
`

// Header styles
export const Header = styled.div`
  padding: 16px;
  background-color: #ffffff;
  color: #000000;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const HeaderTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 500;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  color: #5a616a;

  &:hover {
    color: ${colors.illustration.darkBlue};
  }
`

// Tab styles
export const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f5f5f5;
`

export const Tab = styled.div<{ active: boolean }>`
  padding: 12px 16px;
  cursor: pointer;
  color: #5a616a;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    color: ${colors.illustration.darkBlue};
  }

  ${({ active }) =>
    active &&
    `
    border-bottom: 2px solid ${colors.illustration.darkBlue};
    color: ${colors.illustration.darkBlue};
  `}
`

// Content styles
export const Content = styled.div`
  padding: 40px;
  height: 400px;
  overflow-y: auto;
  background-color: #ffffff;
`

// Dropzone styles
export const Dropzone = styled.div`
  border: 2px dashed #90a0b3;
  border-radius: 4px;
  background-color: #f8fafc;
  padding: 32px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${colors.illustration.darkBlue};
    background-color: #f0f7ff;
  }
`

export const UploadIcon = styled.svg`
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;
  color: ${colors.illustration.darkBlue};
`

export const UploadText = styled.p`
  color: #5a616a;
  font-size: 14px;
  margin-bottom: 8px;
`

export const UploadLink = styled.span`
  color: ${colors.illustration.darkBlue};
  font-weight: 500;
`

export const HelperText = styled.p`
  color: #90a0b3;
  font-size: 12px;
  margin-top: 8px;
`

// URL Upload styles
export const UrlUploadContainer = styled.div`
  margin-top: 32px;
`

export const UrlInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-top: 8px;
`

export const UrlSubmitButton = styled.button<{ disabled?: boolean }>`
  background-color: ${colors.illustration.darkBlue};
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  margin-top: 8px;
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};

  &:hover {
    background-color: ${({ disabled }) =>
      disabled ? colors.illustration.darkBlue : '#0062CC'};
  }
`

// Progress styles
export const ProgressContainer = styled.div`
  margin-top: 16px;
`

export const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  background-color: #e0e0e0;
  border-radius: 2px;
  overflow: hidden;
`

export const ProgressFill = styled.div<{ progress: number }>`
  height: 100%;
  background-color: ${colors.illustration.darkBlue};
  transition: width 0.3s ease;
  width: ${({ progress }) => `${progress}%`};
`

// Error styles
export const ErrorContainer = styled.div`
  margin-bottom: 16px;
  padding: 16px;
  background-color: #fef2f2;
  border: 1px solid #fee2e2;
  border-radius: 8px;
`

export const ErrorTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: #b91c1c;
  margin: 0 0 4px 0;
`

export const ErrorDetails = styled.div`
  font-size: 12px;
  color: #9b1c1c;
  margin-top: 8px;
`

export const ErrorDismissButton = styled.button`
  margin-top: 8px;
  font-size: 12px;
  color: #b91c1c;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #7f1d1d;
  }
`
